import React from 'react';
import PropTypes from 'prop-types';

export default class InputField extends React.Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.state = {
      name: props.name,
    }
  }

  static propTypes = {
    name: PropTypes.string.isRequired,
    errorClass: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onInput: PropTypes.func,
    validator: PropTypes.func
  };

  validate(input) {
    let isValid = true;
    if (this.props.required) {
      isValid = isValid && (input.length > 0);
    } else if (input.length === 0) {
      return true;
    }

    if (this.props.validator) {
      isValid = isValid && this.props.validator(input);
    }

    return isValid;
  }

  onChange(event) {
    const target = event.target;
    const name = target.name;
    const isCheckBox = (target.type === 'checkbox');
    const value = isCheckBox ? target.checked : target.value;

    let isValid = false;
    if (isCheckBox) {
      isValid = true;
    } else {
      isValid = this.validate(value);
    }

    (this.props.onInput && this.props.onInput(name, value, !isValid)); // eslint-disable-line no-unused-expressions
  }

  render() {
    // Don't add `onInput`, `error`, `defautValue` as property
    /* eslint-disable no-unused-vars */
    let {
        validator,
        onInput,
        className,
        defaultValue,
        ...rest
    } = this.props;
    /* eslint-enable no-unused-vars */

    let inputView;
    if (this.props.type === 'textarea') {
      inputView = <textarea onChange={this.onChange}
                            className={className}
                            {...rest} />;
    } else {
      inputView = <input onChange={this.onChange}
                         className={className}
                         {...rest} />;
    }

    return (
        <div className="input-field">
          {inputView}
        </div>
    );
  }
}


/** WEBPACK FOOTER **
 ** ./src/components/FieldComponents/InputField.jsx
 **/